import { createUiKit } from '@barbanet/ui-kit'

import '@barbanet/ui-kit/styles'

export default createUiKit({
	theme: {
		default: {
			name: 'carrier'
		}
	},
	defaults: {
		BSnackbar: {
			position: 'bottom-end',
			closable: true
		}
	}
})
